import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { AppSupervisorFiltersDef } from "./AppSupervisorFiltersDef";

export const AppSupervisorIcon = IconDashboard;
export const AppSupervisorHelpText = '* AppSupervisor.';

export class AppSupervisorFilters extends Entity<AppSupervisorFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new AppSupervisorFiltersDef(), parentKeys);
        this.Form = import('./AppSupervisorFiltersForm').then((module) => module.AppSupervisorFiltersForm);
        this.Title = "AppSupervisor";
        this.HelpText = AppSupervisorHelpText;
        this.Icon = AppSupervisorIcon;
    }
}